import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Import Icons
import settingsLogoWhite from '../../assets/icons/settingsLogoWhite.svg';
import add from '../../assets/icons/add.svg';
import rest from '../../assets/images/rest.png';
import addPMEicon from '../../assets/icons/addPMEiconWhite.svg';
import reportsHover from '../../assets/icons/reportsHover.svg';
import userLogo from '../../assets/icons/userLogo.svg';
// Import Styles
import './quickAccess.css';

const QuickAccess = ({ userData }) => {
    const navigate = useNavigate();

    // Función simple para manejar el scroll horizontal
    const setupScrollButtons = () => {
        // Obtener elementos
        const container = document.querySelector('.buttons-access');
        const prevButton = document.querySelector('.prev-button');
        const nextButton = document.querySelector('.next-button');
        
        if (!container || !prevButton || !nextButton) return;
        
        // Scroll anterior
        prevButton.addEventListener('click', () => {
            container.scrollBy({
                left: -200,
                behavior: 'smooth'
            });
        });
        
        // Scroll siguiente
        nextButton.addEventListener('click', () => {
            container.scrollBy({
                left: 200,
                behavior: 'smooth'
            });
        });
    };

    useEffect(() => {
        // Esperar a que el DOM esté listo
        setTimeout(() => {
            setupScrollButtons();
        }, 300);
        
        // Sin cleanup necesario para esta versión simple
    }, []);

    return (
        <section className='quick-access flex'>
            <h2>Accesos Rápidos</h2>
            <div className='quick-access-buttons flex'>
                <span className='buttons-access flex'>
                    {userData?.permissions === 'admin' && (
                        <button className='button-access flex' onClick={() => navigate('/proyectos/agregar')}>
                            <img src={add} className='icon' alt='Icono crear nuevo proyecto' />
                            <p>Crear Nueva Proyecto</p>
                        </button>
                    )}
                    {(userData?.dimension === 'Sostenedor' || userData?.permissions === 'admin') && (
                        <>
                            <button className='button-access flex' onClick={() => navigate('/proyectos/usuarios')}>
                                <img src={userLogo} className='icon' alt='Icono administrar usuarios' />
                                <p>Administración Usuarios</p>
                            </button>
                            <button className='button-access flex' onClick={() => navigate('/sostenedor/subsidios')}>
                                <img src={add} className='icon' alt='Icono Ingresos subvenciones' />
                                <p>Ingresos Subvenciones</p>
                            </button>
                            <button className='button-access flex' onClick={() => navigate('/sostenedor/remuneraciones')}>
                                <img src={rest} className='icon' alt='Icono gasto remuneraciones' />
                                <p>Gastos Remuneraciones</p>
                            </button>
                        </>
                    )}
                    <button className='button-access flex' onClick={() => navigate('/establecimiento/pme')}>
                        <img src={addPMEicon} className='icon' alt='Icono Ingreso PME' />
                        <p>Ingresar PME</p>
                    </button>
                    <button className='button-access flex' onClick={() => navigate('/finanzas/ejecucionPME')}>
                        <img src={reportsHover} className='icon' alt='Icono ver informe PME' />
                        <p>Ver Informe PME</p>
                    </button>
                    <button className='button-access flex' onClick={() => navigate('/perfil')}>
                        <img src={settingsLogoWhite} className='icon' alt='Icono configuración de perfil' />
                        <p>Configuración de Perfil</p>
                    </button>
                </span>
                <div className='navigation-buttons'>
                    <button className='prev-button'>&#8249;</button>
                    <button className='next-button'>&#8250;</button>
                </div>
            </div>
        </section>
    );
};

export default QuickAccess;